export default "__VITE_ASSET__dbdCSIPs__ 640w, __VITE_ASSET__Cwf4rDB4__ 1024w, __VITE_ASSET__BCZIQlI0__ 1536w";